import { Skeleton } from '@mui/material';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useCreateChartTheme } from '../../../../../theme';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: {
      left: 10,
      right: 10,
    },
  },
  plugins: {
    legend: {
      display: true,
      position: 'top',
    },
  },

  scales: {
    x: {
      stacked: true,
      grid: {
        display: false, // ❌ oculta las líneas verticales
        drawBorder: true,
      },
    },
    y: {
      stacked: true,
      grid: {
        display: true,
        drawBorder: false,
      },
      ticks: {
        beginAtZero: true,
        maxTicksLimit: 20,
        callback: function(value, index, values) {
          const label = this.getLabelForValue(value);
          if (label) {
            // Convierte a formato de nombres propios
            let formattedLabel = label.toLowerCase()
              .split(' ')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ');

            // Trunca si es muy largo
            if (formattedLabel.length > 25) {
              return formattedLabel.substring(0, 22) + '...';
            }
            return formattedLabel;
          }
          return label;
        },
      },
    },
  },
};

export const GraficoBar = ({ labels, datasets, options, ...props }) => {
  const { chartTheme } = useCreateChartTheme({
    ...OPTIONS,
    ...options,
  });

  return (
    <>
      {labels && datasets && labels.length > 0 && datasets.length > 0 ? (
        <Bar options={chartTheme} data={{ labels, datasets }} />
      ) : (
        <Skeleton
          variant='rectangular'
          width={'100%'}
          height={'100%'}
          sx={{ borderRadius: '8px' }}
        />
      )}
    </>
  );
};
